<template>
  <div id="shareModal" class="modal fade" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body d-flex flex-column gap-5">
          <div class="d-flex gap-15 align-items-center">
            <div class="share-icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24" fill="none">
                <path d="M16.6667 24C15.7407 24 14.9537 23.65 14.3056 22.95C13.6574 22.25 13.3333 21.4 13.3333 20.4C13.3333 20.26 13.3426 20.1148 13.3611 19.9644C13.3796 19.814 13.4074 19.6792 13.4444 19.56L5.61111 14.64C5.2963 14.94 4.94444 15.1752 4.55556 15.3456C4.16667 15.516 3.75926 15.6008 3.33333 15.6C2.40741 15.6 1.62037 15.25 0.972222 14.55C0.324074 13.85 0 13 0 12C0 11 0.324074 10.15 0.972222 9.45C1.62037 8.75 2.40741 8.4 3.33333 8.4C3.75926 8.4 4.16667 8.4852 4.55556 8.6556C4.94444 8.826 5.2963 9.0608 5.61111 9.36L13.4444 4.44C13.4074 4.32 13.3796 4.1852 13.3611 4.0356C13.3426 3.886 13.3333 3.7408 13.3333 3.6C13.3333 2.6 13.6574 1.75 14.3056 1.05C14.9537 0.35 15.7407 0 16.6667 0C17.5926 0 18.3796 0.35 19.0278 1.05C19.6759 1.75 20 2.6 20 3.6C20 4.6 19.6759 5.45 19.0278 6.15C18.3796 6.85 17.5926 7.2 16.6667 7.2C16.2407 7.2 15.8333 7.1152 15.4444 6.9456C15.0556 6.776 14.7037 6.5408 14.3889 6.24L6.55556 11.16C6.59259 11.28 6.62037 11.4152 6.63889 11.5656C6.65741 11.716 6.66667 11.8608 6.66667 12C6.66667 12.14 6.65741 12.2852 6.63889 12.4356C6.62037 12.586 6.59259 12.7208 6.55556 12.84L14.3889 17.76C14.7037 17.46 15.0556 17.2252 15.4444 17.0556C15.8333 16.886 16.2407 16.8008 16.6667 16.8C17.5926 16.8 18.3796 17.15 19.0278 17.85C19.6759 18.55 20 19.4 20 20.4C20 21.4 19.6759 22.25 19.0278 22.95C18.3796 23.65 17.5926 24 16.6667 24ZM16.6667 4.8C16.9815 4.8 17.2456 4.6848 17.4589 4.4544C17.6722 4.224 17.7785 3.9392 17.7778 3.6C17.7778 3.26 17.6711 2.9748 17.4578 2.7444C17.2444 2.514 16.9807 2.3992 16.6667 2.4C16.3519 2.4 16.0878 2.5152 15.8744 2.7456C15.6611 2.976 15.5548 3.2608 15.5556 3.6C15.5556 3.94 15.6622 4.2252 15.8756 4.4556C16.0889 4.686 16.3526 4.8008 16.6667 4.8ZM3.33333 13.2C3.64815 13.2 3.91222 13.0848 4.12556 12.8544C4.33889 12.624 4.44519 12.3392 4.44444 12C4.44444 11.66 4.33778 11.3748 4.12444 11.1444C3.91111 10.914 3.64741 10.7992 3.33333 10.8C3.01852 10.8 2.75444 10.9152 2.54111 11.1456C2.32778 11.376 2.22148 11.6608 2.22222 12C2.22222 12.34 2.32889 12.6252 2.54222 12.8556C2.75556 13.086 3.01926 13.2008 3.33333 13.2ZM16.6667 21.6C16.9815 21.6 17.2456 21.4848 17.4589 21.2544C17.6722 21.024 17.7785 20.7392 17.7778 20.4C17.7778 20.06 17.6711 19.7748 17.4578 19.5444C17.2444 19.314 16.9807 19.1992 16.6667 19.2C16.3519 19.2 16.0878 19.3152 15.8744 19.5456C15.6611 19.776 15.5548 20.0608 15.5556 20.4C15.5556 20.74 15.6622 21.0252 15.8756 21.2556C16.0889 21.486 16.3526 21.6008 16.6667 21.6Z" fill="#2E2E2E"/>
              </svg>
            </div>
            <h2>{{ 'Share' | trans }}</h2>
            <strong class="font-size-125 text-main-info">{{selectedFiles}} {{ 'Files' | trans }}</strong>
          </div>
          <div style="padding-top: 20px;">
            <div class="d-flex flex-column gap-20">
              <strong class="font-size-125">{{ 'General access' | trans }}</strong>
              <div class="d-flex gap-10 align-items-center">
                <div class="group-icon-container">
                  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32" fill="none">
                    <path d="M17.5 18.05C19.0913 18.05 20.6174 17.3968 21.7426 16.2341C22.8679 15.0713 23.5 13.4943 23.5 11.85C23.5 10.2057 22.8679 8.62866 21.7426 7.46594C20.6174 6.30321 19.0913 5.65 17.5 5.65C15.9087 5.65 14.3826 6.30321 13.2574 7.46594C12.1321 8.62866 11.5 10.2057 11.5 11.85C11.5 13.4943 12.1321 15.0713 13.2574 16.2341C14.3826 17.3968 15.9087 18.05 17.5 18.05ZM17.5 18.05C15.1131 18.05 12.8239 19.0298 11.136 20.7739C9.44821 22.518 8.5 24.8835 8.5 27.35V32M17.5 18.05C19.8869 18.05 22.1761 19.0298 23.864 20.7739C25.5518 22.518 26.5 24.8835 26.5 27.35V32M19 5.65C19.606 3.0708 22.0225 1 25 1C28.258 1 30.97 3.7745 31 7.2C30.97 10.6255 28.258 13.4 25 13.4M25 13.4H23.5M25 13.4C29.932 13.4 34 17.5633 34 22.7V25.8M16 5.65C15.394 3.0708 12.9775 1 10 1C6.742 1 4.03 3.7745 4 7.2C4.03 10.6255 6.742 13.4 10 13.4M10 13.4H11.5M10 13.4C5.068 13.4 1 17.5633 1 22.7V25.8" stroke="#2E2E2E" stroke-width="2"/>
                  </svg>
                </div>
                <select v-model="accessType" class="form-control btn-group" @change="sendShareScope(accessType)">
                  <option value="private">{{ 'Private' | trans }}</option>
                  <option value="team">{{ 'Team' | trans }}</option>
                  <option value="public">{{ 'Public' | trans }}</option>
                </select>
              </div>
              <small v-if="successMessage" class="text-muted">{{ successMessage }}</small>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="d-flex gap-10">
            <button class="blue-btn font-weight-bold" @click.prevent="getCopyLink">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M10.627 13.373C11.0263 13.7527 11.0263 14.3759 10.627 14.7557C10.2473 15.1355 9.62407 15.1355 9.24431 14.7557C8.33228 13.8423 7.82002 12.6043 7.82002 11.3135C7.82002 10.0227 8.33228 8.78473 9.24431 7.87133L12.6914 4.42428C13.6048 3.51226 14.8428 3 16.1335 3C17.4243 3 18.6623 3.51226 19.5757 4.42428C20.4877 5.33768 21 6.57569 21 7.86646C21 9.15724 20.4877 10.3952 19.5757 11.3086L18.1248 12.7595C18.1346 11.9611 18.008 11.1626 17.7353 10.4031L18.193 9.93567C18.466 9.66564 18.6827 9.34415 18.8306 8.9898C18.9785 8.63546 19.0546 8.2553 19.0546 7.87133C19.0546 7.48736 18.9785 7.1072 18.8306 6.75286C18.6827 6.39852 18.466 6.07703 18.193 5.807C17.923 5.53402 17.6015 5.31731 17.2471 5.16941C16.8928 5.02151 16.5126 4.94536 16.1287 4.94536C15.7447 4.94536 15.3645 5.02151 15.0102 5.16941C14.6559 5.31731 14.3344 5.53402 14.0643 5.807L10.627 9.24431C10.354 9.51434 10.1373 9.83583 9.98944 10.1902C9.84154 10.5445 9.76538 10.9247 9.76538 11.3086C9.76538 11.6926 9.84154 12.0728 9.98944 12.4271C10.1373 12.7815 10.354 13.1029 10.627 13.373ZM13.373 9.24431C13.7527 8.86455 14.3759 8.86455 14.7557 9.24431C15.6677 10.1577 16.18 11.3957 16.18 12.6865C16.18 13.9773 15.6677 15.2153 14.7557 16.1287L11.3086 19.5757C10.3952 20.4877 9.15724 21 7.86646 21C6.57569 21 5.33768 20.4877 4.42428 19.5757C3.51226 18.6623 3 17.4243 3 16.1335C3 14.8428 3.51226 13.6048 4.42428 12.6914L5.87516 11.2405C5.86542 12.039 5.99201 12.8374 6.26466 13.6067L5.807 14.0643C5.53402 14.3344 5.31731 14.6559 5.16941 15.0102C5.02151 15.3645 4.94536 15.7447 4.94536 16.1287C4.94536 16.5126 5.02151 16.8928 5.16941 17.2471C5.31731 17.6015 5.53402 17.923 5.807 18.193C6.07703 18.466 6.39852 18.6827 6.75286 18.8306C7.1072 18.9785 7.48736 19.0546 7.87133 19.0546C8.2553 19.0546 8.63546 18.9785 8.9898 18.8306C9.34415 18.6827 9.66564 18.466 9.93567 18.193L13.373 14.7557C13.646 14.4857 13.8627 14.1642 14.0106 13.8098C14.1585 13.4555 14.2346 13.0753 14.2346 12.6914C14.2346 12.3074 14.1585 11.9272 14.0106 11.5729C13.8627 11.2185 13.646 10.8971 13.373 10.627C13.2784 10.5384 13.203 10.4313 13.1515 10.3124C13.1 10.1935 13.0734 10.0653 13.0734 9.93567C13.0734 9.80606 13.1 9.67784 13.1515 9.55892C13.203 9.44001 13.2784 9.33293 13.373 9.24431Z" fill="#1266F1"/>
              </svg>{{ copyText }}
            </button>
            <button class="blue-btn" @click.prevent="openQrCode">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M3 10V4C3 3.71667 3.096 3.47933 3.288 3.288C3.48 3.09667 3.71733 3.00067 4 3H10C10.2833 3 10.521 3.096 10.713 3.288C10.905 3.48 11.0007 3.71733 11 4V10C11 10.2833 10.904 10.521 10.712 10.713C10.52 10.905 10.2827 11.0007 10 11H4C3.71667 11 3.47933 10.904 3.288 10.712C3.09667 10.52 3.00067 10.2827 3 10ZM5 9H9V5H5V9ZM3 20V14C3 13.7167 3.096 13.4793 3.288 13.288C3.48 13.0967 3.71733 13.0007 4 13H10C10.2833 13 10.521 13.096 10.713 13.288C10.905 13.48 11.0007 13.7173 11 14V20C11 20.2833 10.904 20.521 10.712 20.713C10.52 20.905 10.2827 21.0007 10 21H4C3.71667 21 3.47933 20.904 3.288 20.712C3.09667 20.52 3.00067 20.2827 3 20ZM5 19H9V15H5V19ZM13 10V4C13 3.71667 13.096 3.47933 13.288 3.288C13.48 3.09667 13.7173 3.00067 14 3H20C20.2833 3 20.521 3.096 20.713 3.288C20.905 3.48 21.0007 3.71733 21 4V10C21 10.2833 20.904 10.521 20.712 10.713C20.52 10.905 20.2827 11.0007 20 11H14C13.7167 11 13.4793 10.904 13.288 10.712C13.0967 10.52 13.0007 10.2827 13 10ZM15 9H19V5H15V9ZM19 21V19H21V21H19ZM13 15V13H15V15H13ZM15 17V15H17V17H15ZM13 19V17H15V19H13ZM15 21V19H17V21H15ZM17 19V17H19V19H17ZM17 15V13H19V15H17ZM19 17V15H21V17H19Z" fill="#1266F1"/>
              </svg>
              <strong>{{ 'QR Code' | trans }}</strong>
            </button>
          </div>
          <button class="close-btn" @click.prevent="close">
            <i class="fa fa-times"></i><strong>{{ 'Close' | trans }}</strong>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import { EventBus } from '../../events/event.bus';
import user from "../../mixins/user.mixin";
import currentJob from "../../mixins/current_job.mixin";
import JobManager from "../../manager/JobManager";
import OutputSelectionManager from "../../manager/OutputSelectionManager";
import { EVENT_SHARE, EVENT_QR_SHARE } from "../../events/app.events";
import Analytics from "../../util/Analytics";
import { pageNotification } from '../../../../../../helper/notify';

export default {
  name: 'ShareModal',
  props: {},
  components: {},
  mixins: [store, user, currentJob],
  data() {
    return {
      accessType: 'private',
      successMessage: '',
      copyText: this.translate('Copy Link'),
    };
  },
  mounted: function () {
    $('#shareModal').modal({ show: false });
  },
  created: function () {
    EventBus.$on(EVENT_SHARE, async (data) => {
      const jobShareScope = await JobManager.getShareAccessScope(this.currentJob);
      const isPublic      = jobShareScope.is_public;
      const isTeam        = jobShareScope.is_team;
      
      this.accessType = isPublic ? 'public' : 'private';
      this.accessType = isTeam ? 'team' : this.accessType;

      Analytics.send('result_action', 'open_share', this.currentJob);

      $('#shareModal').modal('show');
    });
  },
  methods: {
    async sendShareScope(scope) {
      this.successMessage = '';
      this.copyText = this.translate('Copy Link');

      try {
        await JobManager.setShareAccessScope(this.currentJob, scope);
        this.successMessage = this.translate('Permission successfully changed');
      } catch (error) {
        pageNotification.error(this.translate('Something went wrong, please try again later!'));
      }
    },
    getCopyLink() {
      navigator.clipboard.writeText(window.location.href)
        .then(() => {
          Analytics.send('result_action', 'copy_link', this.currentJob);
          this.copyText = this.translate('Copied!');
        })
        .catch(err => {
          pageNotification.error(this.translate('Something went wrong, please try again later!'));
        });
    },
    openQrCode() {
      EventBus.$emit(EVENT_QR_SHARE, this.currentJob);
    },
    close() {
      $('#shareModal').modal('hide');

      this.successMessage = '';
      this.copyText = this.translate('Copy Link');
    },
  },
  computed: {
    showPublic() {
      const target = this.currentJob?.apiJob?.conversion[0].target;

      if (target === 'zip' || target === 'texttoimage') {
        return false;
      }
      return true;
    },
    selectedFiles() {
      return OutputSelectionManager.getSelected(this.currentJob).length;
    }
  },
};
</script>
<style lang="scss" scoped>
#shareModal {
  .modal-dialog {
    width: 599px;
    max-width: 95%;
    border-radius: 10px;
    overflow: hidden;
  }

  .modal-content {
    h2 {
      margin: 0;
      font-size: 28px;
      color: #2E2E2E;
    }

    font-size: 17.5px;
    border: 1px solid #ccc;

    p {
      font-size: 17.5px;
    }
  }

  .modal-body {
    display: flex;
    padding: 40px 40px 20px 40px;
    align-items: flex-start;
    align-self: stretch;

    .share-icon-container {
      display: flex;
      padding: 1px 2px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      align-self: stretch;
    }

    .group-icon-container {
      display: flex;
      width: 35px;
      height: 35px;
      padding: 2px 1px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;
    }

    .btn-group {
      display: flex;
      width: 130px;
      // height: 25px;
      background: #F5F5F5;
    }
  }

  .modal-footer {
    display: flex;
    padding: 10px;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    border-radius: 0px 0px 3px 3px;
    border-right: 1px solid #CBCBCB;
    border-bottom: 1px solid #CBCBCB;
    border-left: 1px solid #CBCBCB;
    background: #F2F2F2;

    .blue-btn {
      display: flex;
      height: 38px;
      padding: 7px 10px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      color: #1266F1;
      border-radius: 4px;
      border: 1px solid #1266F1;
      background: #FFF;
    }

    .close-btn {
      display: flex;
      height: 38px;
      padding: 7px 20px;
      margin: 0;
      font-size: 14px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border: 0;
      border-radius: 4px;
      background: #CCC;
    }
  }
}
</style>
